/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const HelpCircle: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.5 17h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm2.57-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26a1.975 1.975 0 00.553-1.803 1.994 1.994 0 00-1.389-1.526 2.008 2.008 0 00-2.466 1.272c-.128.371-.44.647-.833.647h-.291c-.581 0-.987-.564-.825-1.122a4.003 4.003 0 013.225-2.831c1.524-.235 2.969.549 3.873 1.799 1.18 1.632.832 3.385-.187 4.404z" />
    </Icon>
  );
};

export default HelpCircle;

HelpCircle.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
